export const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M15.75 17.75V21.125C15.75 21.746 15.246 22.25 14.625 22.25H4.875C4.57663 22.25 4.29048 22.1315 4.0795 21.9205C3.86853 21.7095 3.75 21.4234 3.75 21.125V8.375C3.75 7.754 4.254 7.25 4.875 7.25H6.75C7.25257 7.24966 7.7543 7.29114 8.25 7.374M15.75 17.75H19.125C19.746 17.75 20.25 17.246 20.25 16.625V11.75C20.25 7.29 17.007 3.589 12.75 2.874C12.2543 2.79114 11.7526 2.74966 11.25 2.75H9.375C8.754 2.75 8.25 3.254 8.25 3.875V7.374M15.75 17.75H9.375C9.07663 17.75 8.79048 17.6315 8.5795 17.4205C8.36853 17.2095 8.25 16.9234 8.25 16.625V7.374M20.25 14V12.125C20.25 11.2299 19.8944 10.3715 19.2615 9.73852C18.6286 9.10558 17.7701 8.75 16.875 8.75H15.375C15.0766 8.75 14.7905 8.63148 14.5795 8.4205C14.3685 8.20952 14.25 7.92337 14.25 7.625V6.125C14.25 5.68179 14.1627 5.24292 13.9931 4.83345C13.8235 4.42397 13.5749 4.05191 13.2615 3.73852C12.9481 3.42512 12.576 3.17652 12.1666 3.00691C11.7571 2.8373 11.3182 2.75 10.875 2.75H9.75"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
